/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Checkout_FailedInputs */

const en_settings_credits_checkout_failed = /** @type {(inputs: Settings_Credits_Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to open checkout page`)
};

const es_settings_credits_checkout_failed = /** @type {(inputs: Settings_Credits_Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to open checkout page`)
};

/**
* | output |
* | --- |
* | "Failed to open checkout page" |
*
* @param {Settings_Credits_Checkout_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_credits_checkout_failed = /** @type {((inputs?: Settings_Credits_Checkout_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Checkout_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_checkout_failed(inputs)
	return es_settings_credits_checkout_failed(inputs)
});